// extracted by mini-css-extract-plugin
module.exports = {"table":"Receipt_table__3vodH","payment-term-row":"Receipt_payment-term-row__HAcEt","paymentTermRow":"Receipt_payment-term-row__HAcEt"};